import { render, staticRenderFns } from "./Banner10.vue?vue&type=template&id=404271cc"
import script from "./Banner10.vue?vue&type=script&lang=js"
export * from "./Banner10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports